import { IconButton, type IconButtonProps } from "~/common/mui";

export type SearchInputGroupIconButtonProps = IconButtonProps;

export const SearchInputGroupIconButton = (props: SearchInputGroupIconButtonProps) => {
  return <IconButton variant="contained" color="secondary" size="large" {...props} />;
};
